var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftMembershipStepPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_gift_pencil)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.325 4.46272C23.325 4.16272 23.2125 3.86272 22.9875 3.63772C22.5375 3.18772 22.0875 2.73772 21.675 2.28772C21.2625 1.87522 20.8875 1.46272 20.475 1.08772C20.2875 0.862724 20.0625 0.712724 19.7625 0.675224C19.425 0.637724 19.125 0.712724 18.8625 0.937724L16.3125 3.48772H3.03749C1.76249 3.48772 0.674988 4.53772 0.674988 5.85022V21.0002C0.674988 22.2752 1.72499 23.3627 3.03749 23.3627H18.225C19.5 23.3627 20.5875 22.3127 20.5875 21.0002V7.68772L23.025 5.25022C23.2125 5.02522 23.325 4.76272 23.325 4.46272ZM12.3 13.5002C12.2625 13.5377 12.2625 13.5377 12.225 13.5377L9.52499 14.4377L10.425 11.7377C10.425 11.7002 10.4625 11.7002 10.4625 11.6627L17.2125 4.91272L19.0875 6.75022L12.3 13.5002ZM18.8625 21.0002C18.8625 21.3752 18.5625 21.6752 18.1875 21.6752H3.03749C2.66249 21.6752 2.36249 21.3752 2.36249 21.0002V5.81272C2.36249 5.43772 2.66249 5.13772 3.03749 5.13772H14.5875L9.26249 10.5002C9.07499 10.6877 8.88749 10.9502 8.81249 11.2502L7.42499 15.4502C7.31249 15.7502 7.38749 16.0127 7.53749 16.2752C7.64999 16.4252 7.87499 16.6502 8.28749 16.6502H8.43749L12.75 15.2252C13.0125 15.1502 13.275 14.9627 13.4625 14.7752L18.8625 9.37522V21.0002ZM20.25 5.58772L18.375 3.75022L19.5375 2.58772C19.8375 2.88772 21.075 4.12522 21.375 4.46272L20.25 5.58772Z",
    fill: "#284993"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_gift_pencil"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftMembershipStepPencil);
export default __webpack_public_path__ + "static/media/gift-membership-step-pencil.08b4433e0b83bb51bc6d7da07259a4b4.svg";
export { ForwardRef as ReactComponent };